<template>
  <div class="lead lead-modal">
    <div class="lead__inner">
      <button
        class="lead__close m-btn"
        @click="closeModal"
      >
        <img
          src="/v2/catalog/repetitor/close.svg"
          alt="cross"
          class="lead__close-icon"
        >
      </button>

      <div
        class="lead__form"
        @keypress.enter="submit"
      >
        <h2
          v-if="consult"
          class="lead__title"
        >
          Оставьте заявку и сотрудник отдела заботы поможет <br> с выбором репетитора
        </h2>
        <h2
          v-else
          class="lead__title"
        >
          Записаться на <span>бесплатный</span> пробный урок и диагностику
        </h2>

        <form-name-field
          ref="nameField"
          v-model="nameInput"
          class="form__input"
          placeholder="Имя"
          round-border
        />

        <form-phone-field
          ref="phoneField"
          v-model="phoneInput"
          class="form__input form__input_phone"
          :errors-list="submitError"
          :error="validForm === false"
          round-border
        />

        <form-email-field
          ref="emailField"
          v-model="emailInput"
          class="form__input form__input_email"
          :submit-error="submitError"
          round-border
          placeholder="Почта"
          @clearSubmitError="clearSubmitError"
        />

        <button
          class="m-btn lead__form_submit"
          @click="submit"
        >
          {{ consult ? 'Оставить заявку' : 'Записаться на урок' }}
        </button>

        <span class="lead__form_privacy">
          Нажимая на кнопку, вы соглашаетесь
          <nuxt-link
            :to="routeIsArsenal ? '/privacy-arsenal' : '/privacy'"
            target="_blank"
          >
            с условиями обработки данных
          </nuxt-link>
        </span>

        <div class="lead__form__social">
          <p>
            Или напишите нам в чат:
          </p>

          <div class="lead__form__social-items">
            <a
              href="https://wa.me/79686286327"
              target="_blank"
              rel="nofollow"
              class="whatsapp"
            >
              <img
                src="/v2/ege/modal/whatsapp.svg"
                alt="whatsapp"
              >
            </a>
            <a
              :href="$telegramBotLink($route)"
              target="_blank"
              rel="nofollow"
              class="telegram"
            >
              <img
                src="/v2/ege/modal/telegram.svg"
                alt="telegram"
              >
            </a>
            <a
              href="mailto:online.school@synergy.ru"
              target="_blank"
              rel="nofollow"
              class="email"
            >
              <img
                src="/v2/ege/modal/email.svg"
                alt="email"
              >
            </a>
          </div>
        </div>
      </div>
    </div>

    <div
      class="lead__overlay"
      @click="closeModal"
    />
  </div>
</template>

<script>
import routeIsArsenal from '~/utils/routeIsArsenal';
import sendLeadMixinConstructor from '@/mixins/sendLeadMixinConstructor';
import FormNameField from '@/components/v2/common/fileds/FormNameField.vue';
import FormEmailField from '@/components/v2/common/fileds/FormEmailField.vue';
import FormPhoneField from '@/components/v2/common/fileds/FormPhoneField.vue';

const sendLeadMixin = sendLeadMixinConstructor({
  needPhone: true,
  needEmail: true,
  needToSendTitle: true,
});

export default {
  name: 'RepetitorModal',
  components: {
    FormPhoneField,
    FormEmailField,
    FormNameField,
  },
  mixins: [sendLeadMixin],
  props: {
    consult: {
      type: Boolean,
      default: false,
    },
    card: {
      type: Object,
      default: null,
    },
  },
  computed: {
    routeIsArsenal() {
      return routeIsArsenal(this.$route.name);
    },
    titleToSend() {
      return this.card?.title || '';
    },
  },

  mounted() {
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto';
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.lead {
  .lead__inner {
    position: fixed;
    z-index: 100;
    inset: 0;

    width: min(545px, calc(100% - 16px));
    height: fit-content;
    max-height: 95vh;
    margin: auto;

    border-radius: 20px;
    background-color: $white-color;
    box-shadow: 10px 10px 50px rgba(7, 21, 57, 0.1), 4px 4px 20px rgba(7, 21, 57, 0.05);

    overflow: hidden;

    @include media-down(tablet) {
      padding-top: 16px;
      padding-bottom: 40px;
      box-shadow: 2px 4px 0 0 $black;
    }
  }

  .lead__close {
    position: absolute;
    z-index: 1;
    top: 10px;
    right: 10px;
  }

  .lead__title {
    margin-bottom: 32px;

    color: $black;
    text-align: center;
    font-weight: 800;
    font-size: 34px;
    line-height: 110%;
    letter-spacing: -0.01em;

    @include media-down(tablet) {
      margin-inline: auto;
      margin-bottom: 16px;
      max-width: 410px;

      font-size: 24px;
      letter-spacing: 0;
    }

    @include media-down(mobile) {
      max-width: 312px;
    }

    span {
      color: #FB5018;
    }
  }

  .lead__form {
    position: relative;
    padding: 40px 40px 32px;

    @include media-down(tablet) {
      margin-top: 10px;
      max-width: 450px;
      margin-left: auto;
      margin-right: auto;

      padding: 12px 8px;
    }

    .form__input {
      margin-bottom: 8px;

      ::v-deep input:not(.phone-field__input) {
        width: 100%;
        height: auto;
        padding: 22px 18px 24px;

        color: $black;
        font-size: 20px;
        letter-spacing: 0.4px;
        border-radius: 15px;
        border: 2px solid rgba($black-color, 0.2);

        @include media-down(mobile) {
          padding: 16px 14px 17px;
          font-size: 18px;
          letter-spacing: 0.36px;
        }
      }
    }

    .lead__form_submit {
      margin-top: 16px;
      margin-bottom: 16px;
      padding: 17px 23px 23px;

      background-color: $ege-orange;
      border: 2px solid $brown-dark;
      box-shadow: 0 4px 0 $brown-dark;
      border-radius: 100px;
      transition: 300ms;

      color: $white-color;
      font-variant-numeric: lining-nums proportional-nums;
      font-size: 30px;
      line-height: 100%;
      font-weight: 700;
      width: 100%;
      cursor: pointer;

      &:hover {
        box-shadow: none;
        transform: translateY(4px);
      }

      @include media-down(mobile) {
        padding: 15px 10px 16px;
        font-size: 18px;
      }
    }

    .lead__form_privacy {
      text-align: center;
      color: $black;
      font-variant-numeric: lining-nums proportional-nums;
      font-size: 18px;
      font-weight: 600;
      line-height: 100%;
      display: block;

      @include media-down(tablet) {
        font-weight: 500;
      }

      a {
        display: inline-block;
        color: #E8553E;
      }
    }
  }

  .lead__overlay {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: pointer;

    background-color: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(2.5px);
  }

  .lead__form__social {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 32px;

    @include media-down(mobile) {
      margin-top: 32px;
    }

    &-items {
      display: flex;
      justify-content: center;
      gap: 10px;

      @include media-down(tablet) {
        margin-top: 12px;
      }
    }

    p {
      margin-bottom: 0;
      text-align: center;
      font-weight: 500;
      font-size: 20px;
      line-height: 130%;
      letter-spacing: -0.01em;
      font-feature-settings: 'pnum' on, 'lnum' on;
      color: $black;
    }

    a {
      display: inline-block;
      width: 50px;
      height: 50px;
      overflow: hidden;

      border-radius: 10px;
      transform: translate(-2px, -2px);

      transition: transform .2s ease-out, box-shadow .2s ease-out;

      img {
        width: 100%;
      }
    }
    a.whatsapp {
      border: 2px solid #168B25;
      box-shadow: 2px 2px 0 0 #168B25;

      &:hover {
        transform: translate(0, 0);
        box-shadow: 0 0 0 0 #168B25;
      }
    }
    a.telegram {
      border: 2px solid #016EA3;
      box-shadow: 2px 2px 0 0 #016EA3;

      &:hover {
        transform: translate(0, 0);
        box-shadow: 0 0 0 0 #016EA3;
      }
    }
    a.email {
      border: 2px solid #044396;
      box-shadow: 2px 2px 0 0 #044396;

      &:hover {
        transform: translate(0, 0);
        box-shadow: 0 0 0 0 #044396;
      }
    }
  }
}

</style>
